































import { ApexOptions } from 'apexcharts'
import moment from 'moment'
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import { Component, Prop } from 'vue-property-decorator'

import { ApexChartLocales, ApexChartSeries } from '../../../../../shared/types/ApexChartSeries.types'
import { fromToTicks } from '../../../../../shared/utils/fromToTicks'
import { seriesByMetricInList } from '../../../../../shared/utils/seriesByMetricInList'
import { FlowStatisticsMode } from '../../logic/Editor/types'
import { FlowStatistics } from '../../logic/FlowStatistics'

@Component({
  components: {
    VueApexCharts
  }
})
export default class ConnectionStatisticsModal extends Vue {
  @Prop() statistics!: FlowStatistics

  isModalOpen = true

  chartSeries: ApexChartSeries = []

  get fromDate() {
    return this.statistics.statSetting.from
  }

  get toDate() {
    return this.statistics.statSetting.to
  }

  get fromTo() {
    return fromToTicks(this.fromDate, this.toDate)
  }

  get modalTitle() {
    if (this.statistics) {
      return this.$t(`connection_statistics_modal_criteria_${ this.statistics.statSetting.mode }_title`)
    }

    return ''
  }

  get lineOptions(): ApexOptions {
    return {
      chart: {
        defaultLocale: this.$i18n.locale,
        locales: ApexChartLocales,
        animations: {
          enabled: false,
        },
        toolbar: {
          show: true,
        },
        zoom: {
          allowMouseWheelZoom: false
        }
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2.5,
      },
      xaxis: {
        type: 'datetime',
        categories: this.fromTo.timeTicks,
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          formatter: (value:any) => parseInt(value).toString(),
        },
      },
      tooltip: {
        x: { show: false },
      }
    }
  }

  formattedDate(date:string) {
    return moment(date).format('LL')
  }

  mounted() {
      const { selectedConnection } = this.statistics

      if (selectedConnection) {
        const { statistics } = selectedConnection.data

        if (statistics) {
          if (statistics.criteria !== FlowStatisticsMode.User) {
            this.statistics.getConnectionStatistics(statistics.inputKey.toString(), statistics.outputKey.toString())
              .then(data => {
                seriesByMetricInList(this.$i18n, data, [ statistics.criteria ], this.fromTo, 'date')
                  .calcSeries([ { name: this.$t(`flow_statistics_metric_${ statistics.criteria }_title`).toString() } ])
                  .then(res => {
                    this.chartSeries = res
                  })
              })
          } else {
            seriesByMetricInList(this.$i18n, this.statistics.prepareUserStatForFrontend(statistics), [ 'user' ], this.fromTo, 'date')
              .calcSeries([ { name: this.$t('flow_statistics_metric_user_title').toString() } ])
              .then(res => {
                this.chartSeries = res
              })
          }
        }
      }
  }
}
